<template>
  <div v-show="historyList.length" class="search-history-oldnew">
    <div class="title">
      <img
        :src="require('../../../../../common/images/oldnew/history.png')"
        alt=""
      />
      <span>最近搜索</span>
    </div>
    <ul class="history-wrap">
      <li
        @click="itemHandle(item)"
        v-for="(item, index) in historyList"
        :key="index"
        class="item"
      >
        {{ item }}
      </li>
    </ul>
    <div class="clear-hs">
      <img
        :src="require('../../../../../common/images/oldnew/clear.png')"
        alt=""
      />
      <span @click="clearHistory">清空最近搜索</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      historyList: JSON.parse(localStorage.getItem("oldNewHistory")) || [],
    };
  },
  methods: {
    clearHistory() {
      localStorage.clear("oldNewHistory");
      this.historyList = [];
    },
    itemHandle(value) {
      this.$parent.searchHandle(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-history-oldnew {
  .title {
    margin-top: 54px;
    padding: 0 30px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 14px;
    }
    span {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
    }
  }
  .history-wrap {
    padding: 0 30px;
    margin-bottom: 92px;
    .item {
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 24px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      padding: 16px 30px;
      max-width: 594px;

      background: #f6f6f6;
      border-radius: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .clear-hs {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 28px;
      height: 32px;
      margin-right: 16px;
    }
  }
}
</style>
